/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import uuid from 'uuid'
import {
  formatNumber,
  getBettingTime,
  getPickPublishMoney,
  getRatioTicketMoney,
  showToast,
  TOAST_TYPE,
} from '@utils/utils'
import { TxtLimit } from '@styles/base.style'
import { Button } from '@styles/button.style'
// image
import DummyImg from '@assets/images/itemshop/skin_dummy.png'
import { DiaIco, GmoneyIco } from '@shared/Icon/MoneyIcon'
// css
import { Schema$Message } from '@v2/protocol/message'
import MessageContentPopup from '@views/Popup/MessageContentPopup'
import { BET_HIT_STATE, MESSAGE_TYPE, PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import useRootStore from '@store/useRootStore'
import { PickMessageWrap } from '@views/Pick/PickList/index.style'
import { MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY, PUBLISH_PICK_TYPE } from '@constants/index'
import { SharedBetStyle } from '@views/Popup/MessageContentPopup/index.style'
import { BettingHistoryHeader } from '@views/BettingHistory/BettingHistoryListItem/index.style'
import SuccessImg from '@assets/images/icon/betting_history_icon/success.png'
import FailImg from '@assets/images/icon/betting_history_icon/fail.png'
import CancelImg from '@assets/images/icon/betting_history_icon/cancel.png'
import { isMobile } from 'react-device-detect'
import * as _ from 'lodash'
import { getSportIconElementsAscendingOrderBySportIdAndRemoveDuplicated } from '@utils/jsxutils'
import { MessageFooter } from '../index.style'
import DialogUtils from '@utils/dialog-utils'
import { COMMUNICATION_BLOCK_TYPE, FROM_VIEW_TYPE } from '@v2/constants/common'
import dayjs from 'dayjs'

const Gmoney = (
  <GmoneyIco/>
)

interface MessageListItemFooterProps {
  index: MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY
  track: Schema$Message
  onDelete: (arg: string) => void
  onShowPick: () => void
  messageType?: string
  onReceiveHandler: () => void
  onUserBlockSuccessHandler: (userPromiseId: string, blockTypes: COMMUNICATION_BLOCK_TYPE[]) => void
}

const MessageListItemFooter: React.FC<MessageListItemFooterProps> = (props: MessageListItemFooterProps) => {
  const { index, track, onDelete, onShowPick, messageType, onReceiveHandler, onUserBlockSuccessHandler } = props
  const { globalStore, bettingHistoryStore, messageStore, componentStore, matchupStore } = useRootStore()
  const days = ['일', '월', '화', '수', '목', '금', '토']
  const { pick, sharedBettingHistory } = track

  const isClubMessage = track.type === MESSAGE_TYPE.CLUB_TO_MEMBER || track.type === MESSAGE_TYPE.CLUB_TO_ALL_MEMBER

  // TODO 중복되는 코드가 존재하므로 찾아서 개선할 것. - MessageContent.tsx#getDateFormat, MessageListItemFooter.tsx#getDateFormat
  const getDateFormat = (date: string): string => {
    const d = dayjs(date)
    const f = [d.format('MM/DD'), '(', _.nth(days, d.day()), ') ', d.format('HH:mm')]
    return f.join('')
  }

  // 메시지 팝업
  const [visiblePopup, setVisiblePopup] = useState(false)
  const onShowMessagePopup = () => {
    messageStore.setReceiveUser(undefined)
    bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.MESSAGE)
    bettingHistoryStore.setBettingHistoryInitProps({ onlyMajorClub: false, fromViewType: FROM_VIEW_TYPE.MESSAGE })
    setVisiblePopup(true)
  }

  const isUserBlockEnabled = globalStore.getUserBlockEnabled()
  const isPossibleUserBlock = globalStore.isPossibleUserBlockByUserPromiseId(track?.senderId)
  const userBlock = track.isBlocked
  const onClickBlockUser = (): void => {
    const {
      senderId: userPromiseId,
      senderNick: userNick,
      senderProfileImg: userProfileImg,
    } = track
    if (!userBlock) {
      DialogUtils.showUserBlock(userPromiseId, userNick, userProfileImg, onUserBlockSuccessHandler)
    } else {
      DialogUtils.showUserUnBlock(userPromiseId, onUserBlockSuccessHandler)
    }
  }

  // 개별 삭제
  const onClickDeleteMessage = () => {
    const { id } = track

    globalStore.pushDialogYesNo({
      title: `${messageType || '메시지'} 삭제`,
      text: ['삭제 후 복원이 불가능합니다.', '삭제하시겠습니까?'],
      negativePress: '취소',
      positivePress: '삭제',
      callbackPositive: () => {
        onDelete(id)
      },
    })
  }

  if (track) {
    switch (track.type) {
      case MESSAGE_TYPE.SYSTEM:
        break
      case MESSAGE_TYPE.NORMAL:
        break
      case MESSAGE_TYPE.GIFT:
        break
      case MESSAGE_TYPE.REWARD:
        break
      case MESSAGE_TYPE.PICK_ADD:
        break
    }
  }

  const className = []
  if (track.type === MESSAGE_TYPE.PICK_ADD) {
    className.push('pick-content')
  }

  if (track.type === MESSAGE_TYPE.BETTING_HISTORY_SHARE) {
    className.push('pick-content')
  }

  const blockBtn = []
  const button = []
  if (index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.RECEIVE && track.senderId && !isClubMessage) {
    button.push(
      <Button
        key={`messageListFooter:button1:${track.id}`}
        secondary
        className="message-footer-btn"
        onClick={onShowMessagePopup}
      >
        답장
      </Button>,
    )
    if (isUserBlockEnabled && isPossibleUserBlock) {
      blockBtn.push(
        <Button className={userBlock ? 'message-footer-btn block-clear' : 'message-footer-btn blocked'}
                onClick={onClickBlockUser}>
          {userBlock ? '차단해제' : '차단'}
        </Button>,
      )
    }
  } else if (index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.SENT
    && track.receiverId && componentStore.extraClubId == null) {
    button.push(
      <Button
        key={`messageListFooter:button2:${track.id}`}
        secondary
        className="message-footer-btn"
        onClick={onShowMessagePopup}
      >
        보내기
      </Button>,
    )
  }

  const showToastMessageAlreadyBuyPick = () => showToast(TOAST_TYPE.INFO, '이미 구매한 픽입니다.')
  const showToastMessageEndPick = () =>
    showToast(TOAST_TYPE.INFO, '베팅이 마감되거나 공유가 중지된 픽은 구매할 수 없습니다.')
  // const openBettingShareDetailPopup = async () => {
  //   const betRecord = bettingHistoryStore.schema$BettorBetRecordToBettingRecordTrack(track.sharedBettingHistory)
  //   bettingHistoryStore.setSelectedBettingHistoryByBettingRecordTrack(betRecord)
  //   globalStore.toggleBettingShareDetailPopupVisible(true)
  // }
  const onClickSaveBettingList = () => {
    onReceiveHandler()
  }

  let bettingHistoryShareContent
  if (sharedBettingHistory && sharedBettingHistory.bet) {
    const { bet, folds } = sharedBettingHistory
    const {
      createdAt,
      foldCount,
      betMoney,
      dividend,
      dividendRate,
      betMoneyType,
      hitState,
    } = bet

    const finalBetMoney = betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G ? getRatioTicketMoney(betMoney) : betMoney
    const finalDividend = betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G ? getRatioTicketMoney(dividend) : dividend
    const dateOfBet = getBettingTime(createdAt)

    const sportIconElements = _.map(getSportIconElementsAscendingOrderBySportIdAndRemoveDuplicated(
      _.map(folds, fold => fold.sportId), matchupStore.feedSupplier), element => (
      <span key={uuid.v4()}>
      {element}
    </span>
    ))

    // const makeElementHitStateCircle = (foldHitState: number[]) => {
    //   const circleClassNames = []
    //   const elCircles = []
    //   for (const state of foldHitState) {
    //     switch (state) {
    //       case BET_HIT_STATE.SUCCESS:
    //         circleClassNames.push('success')
    //         break
    //       case BET_HIT_STATE.CANCEL:
    //         circleClassNames.push('cancel')
    //         break
    //       case BET_HIT_STATE.ONGOING:
    //         circleClassNames.push('ongoing')
    //         break
    //     }
    //   }
    //
    //   let keyIndex = 0
    //   for (const className of circleClassNames) {
    //     keyIndex += 1
    //     const key = `match-state-circle-${className}-${keyIndex}`
    //     elCircles.push(<span key={key} className={`match-state--circle ${className}`}/>)
    //   }
    //
    //   return (<div className="match-state">{elCircles}</div>)
    // }
    //
    // const elOnGoingHitStateCircle = () => {
    //   const foldHitState: number[] = []
    //   for (const key in folds) {
    //     const fold = folds[key]
    //     for (const data of fold.data) {
    //       foldHitState.push(data.hitState)
    //     }
    //   }
    //
    //   return makeElementHitStateCircle(foldHitState)
    // }

    let eleHitState
    switch (hitState) {
      case BET_HIT_STATE.SUCCESS:
        eleHitState = <img src={SuccessImg} alt="적중" className="hit-state-img"/>
        break
      case BET_HIT_STATE.FAIL:
        eleHitState = <img src={FailImg} alt="미적중" className="hit-state-img"/>
        break
      case BET_HIT_STATE.CANCEL:
        eleHitState = <img src={CancelImg} alt="적중 특례" className="hit-state-img"/>
        break
      case BET_HIT_STATE.ONGOING:
        // eleHitState = elOnGoingHitStateCircle()
        eleHitState = <Fragment/>
        break
    }

    bettingHistoryShareContent = (
      <BettingHistoryHeader css={SharedBetStyle} className="received">
        <div className="top-info">
          {dateOfBet}
          {/*<span className="bet-date">{dateOfBet}</span>*/}
          {/*<Button className="share-btn" onClick={openBettingShareDetailPopup}>*/}
          {/*  상세*/}
          {/*</Button>*/}
          {index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.RECEIVE ? (
            <Fragment>
              <Button TP className="message-bet-btn save" onClick={onClickSaveBettingList}>
                저장
              </Button>
              <Button TP className="message-bet-btn save-complete">
                저장완료
              </Button>
            </Fragment>
          ) : null}
          <div className="betting-history-header">
            <div className="my-bet-info">
              {eleHitState}
              <ul className="my-bet-info--list">
                <li className="my-bet-info--list--item money">
                  {formatNumber(finalBetMoney)}
                  {betMoneyType === PROPERTY_ID.DIA && <DiaIco/>}
                  {(betMoneyType === PROPERTY_ID.MONEY || betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) &&
                    <GmoneyIco/>}
                </li>
                <li className="my-bet-info--list--item rate">
                  {Number(dividendRate).toFixed(2)}
                </li>
              </ul>
            </div>

            <div className="division-line header"/>

            <ul className="fold-money-list">
              <li className="fold-money-list--item fold">
                {foldCount}

                <div className="sports-ico-wrap">
                  {sportIconElements}
                </div>
              </li>
              <li className="fold-money-list--item final-dividend">
                {betMoneyType === PROPERTY_ID.DIA && '예상적중다이아'}
                {(betMoneyType === PROPERTY_ID.MONEY || betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) && '예상적중머니'}
                <span className="final-dividend-value">{formatNumber(finalDividend)}</span>
                {betMoneyType === PROPERTY_ID.DIA && <DiaIco/>}
                {(betMoneyType === PROPERTY_ID.MONEY || betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) && <GmoneyIco/>}
              </li>
            </ul>
          </div>
        </div>
      </BettingHistoryHeader>
    )
  }

  const baseContent = (
    <span className="message-footer-btn-wrap">
      {blockBtn}
      <Button className="message-footer-btn delete" onClick={onClickDeleteMessage}>
        {/*{Trash}*/}
        삭제
      </Button>
      {button}
    </span>
  )

  let pickContent
  if (pick) {
    const {
      dateBettingEnd,
      title,
      picksterName,
      userHitRatioTotal,
      foldCount,
      dividendRate,
      publishMoneyType,
    } = pick
    const pickPrice = getPickPublishMoney(pick.publishMoneyType, pick.priceMoney)

    pickContent = (
      <PickMessageWrap className={className.join(' ')}>
        {index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.RECEIVE ? (
          <Fragment>
            <Button secondary onClick={onShowPick} className="message-pick-btn buy">
              픽 구매
            </Button>
            <Button onClick={showToastMessageAlreadyBuyPick} className="message-pick-btn complete">
              구매완료
            </Button>
            <Button onClick={showToastMessageEndPick} className="message-pick-btn end">
              구매불가
            </Button>
          </Fragment>
        ) : null}
        <span className="bet-date">베팅마감 {getDateFormat(dateBettingEnd)}</span>
        <h3 className="pick-list-tit">{title}</h3>

        <div className={isMobile ? 'pick-list' : 'pick-list pc-pick-list'}>
          <span className="pickster-info">
            <img key="dummy" src={DummyImg} alt="프로필" className="pickster-img"/>
            <div className="pickster">
              <div className="pickster--name">{picksterName}</div>
              <span className="pickster--hit-rate">
                적중률
              </span>
              <span className="pickster--percent">{`${userHitRatioTotal}%`}</span>
            </div>
          </span>

          <ul className="pick-info">
            <li className="pick-info-item">
              <span className="txt">폴드</span>
              <span className="num">{foldCount}</span>
            </li>
            <li className="pick-info-item">
              <span className="txt">배당</span>
              <span className="num point">{dividendRate}</span>
            </li>
            <li className="pick-info-item price">
              <span className="txt">판매가</span>
              <span className="money-wrap">
                <span className="money-wrap--money" css={TxtLimit}>{formatNumber(pickPrice)}</span>
                {publishMoneyType === PUBLISH_PICK_TYPE.HEART ? Gmoney : '개'}
              </span>
            </li>
          </ul>
        </div>
      </PickMessageWrap>
    )
  }

  // const test = (
  //   <BettingHistoryHeader css={SharedBetStyle} className="received">
  //     <div id="bettingHistoryTopInfo" className="top-info">
  //       <Button TP className="message-bet-btn save">
  //         저장
  //       </Button>
  //       <span className="bet-date">10/12</span>
  //       <div className="betting-history-header">
  //         <div className="my-bet-info">
  //           <img src={SuccessImg} alt="적중" className="hit-state-img"/>
  //           <ul className="my-bet-info--list">
  //             <li className="my-bet-info--list--item money">
  //               100,000
  //               <GmoneyIco/>
  //             </li>
  //             <li className="my-bet-info--list--item rate">
  //               10.21
  //             </li>
  //           </ul>
  //         </div>
  //         <ul className="fold-money-list">
  //           <li className="fold-money-list--item fold">
  //             10
  //           </li>
  //           <li className="fold-money-list--item final-dividend">
  //             예상적중머니
  //             <span className="final-dividend-value">100,000</span>
  //             <GmoneyIco/>
  //           </li>
  //         </ul>
  //       </div>
  //     </div>
  //   </BettingHistoryHeader>
  // )
  return (
    <Fragment>
      <div css={MessageFooter}>
        {/*{test}*/}
        {track.type === MESSAGE_TYPE.PICK_ADD && pickContent}
        {track.type === MESSAGE_TYPE.BETTING_HISTORY_SHARE && bettingHistoryShareContent}
        {baseContent}
      </div>

      {/* 메시지 보내기 팝업 */}
      <MessageContentPopup
        key={`${track.id}_content`}
        visible={visiblePopup}
        setVisible={setVisiblePopup}
        messageType={messageType}
        receive={
          index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.RECEIVE
            ? { id: track.senderId, nick: track.senderNick, title: track.title }
            : { id: track.receiverId, nick: track.receiverNick, title: track.title }
        }
        useRequestWaitTimer
        fromViewType={FROM_VIEW_TYPE.MESSAGE}
      />
    </Fragment>
  )
}

export default MessageListItemFooter
